import MutationTypes from '../../MutationTypes';

export default {
    [MutationTypes.SET_IS_LOADING]: (state, payload) => {
        state.isLoading = payload;
    }
};
